<template>
    <section>
        <p>欢迎使用美游美在线客服，如有任何疑问请点击右下角咨询按钮。</p>
        <CustomerService/>
    </section>
</template>

<script>
import CustomerService from '@/components/customerService'
export default {
    data() {
        return {
            imgUrl: ''
        }
    },
    components: {
        CustomerService
    },
    created() {
    },
    mounted() {
        
    },
    methods: {
       
    }
}
</script>

<style lang="scss" scoped>
p{
    padding: 20px 24px;
    width: calc(100% - 48px);
    font-size: 16px;
    line-height: 30px;
}
</style>
